import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider } from '@mui/material';
import { Page, Header } from 'components';
import { ToggleRemoveRepositoryFileDialog, RemoveRepositoryFile } from '../actions/RepositoryPdfActions';
import RepositoryForm from './components/RepositoryPdfForm';
import RepositoryFileRemoveDialog from './components/RepositoryPdfFileRemoveDialog';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const Repository = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const removeRepoFileDialogVisibility = useSelector((state) => state.repositoryPdfReducer.removeRepoFileDialogVisibility);

	const _repoFileRemoveDialogClose = () => {
		dispatch(ToggleRemoveRepositoryFileDialog(false));
	};

	return (
		<Page className={classes.root} title="PDF Repository">
			<Header module="Modules" view="PDF Repository" />
			<RepositoryForm />
			{removeRepoFileDialogVisibility && (
				<RepositoryFileRemoveDialog
					onClose={_repoFileRemoveDialogClose}
					open={removeRepoFileDialogVisibility}
				/>
			)}
		</Page>

	);
};

export default Repository;
